import React, { useState, useEffect, useRef } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Iconos personalizados para los marcadores
const redIcon = new L.Icon({
  iconUrl: 'https://apps-plz.s3.us-east-1.amazonaws.com/maps/home-4.png',
  iconSize: [90, 60],
  popupAnchor: [0, -60],
  shadowSize: [60, 60]
});
const HomeIcon = new L.Icon({
    iconUrl: 'https://apps-plz.s3.us-east-1.amazonaws.com/maps/company.png',
    iconSize: [60, 60],
    iconAnchor: [30, 60],
    popupAnchor: [0, -60],
    shadowSize: [60, 60]
  });
const blueIcon = new L.Icon({
    iconUrl: 'https://apps-plz.s3.us-east-1.amazonaws.com/maps/delivery.png',
    iconSize: [60, 60],
    iconAnchor: [44, 90],
    popupAnchor: [0, -90],
    shadowSize: [90, 90],
});

const MapComponent =  ({
    detailOrder
  }) => {
  const [position, setPosition] = useState([detailOrder.branch.latitude,detailOrder.branch.longitude]);
  const [branch, setBranch] = useState([detailOrder.branch.latitude,detailOrder.branch.longitude]);
  const [client, setClient] = useState([detailOrder.client.latitude,detailOrder.client.longitude]);
  const [delivery, setDelivery] = useState(
    detailOrder.delivery ? [detailOrder.delivery.latitude, detailOrder.delivery.longitude] : null
  );
  const mapRef = useRef(null);



  const traking = async () => {
    const urlListaDirecciones = `${process.env.REACT_APP_API_URL}/track/${detailOrder.uuid}`;
    const respuesta = await fetch(urlListaDirecciones, {
      method: "get",     
    }).then((respuesta) => respuesta.json());
    console.log(respuesta.data.delivery.latitude); 
    setPosition([
      respuesta.data.delivery.latitude,
      respuesta.data.delivery.longitude
    ]);
    if (mapRef.current) {
      mapRef.current.setView(position, 13); // Ajusta el zoom a 13 y centra en el marcador
    }
  };

  // Cambiar la posición del marcador cada 15 segundos
   useEffect(() => {
    const interval = setInterval(() => {
      traking();
      
      /**/
    }, 30000);
    return () => clearInterval(interval);
  }, [position]);

  return (
    <MapContainer center={position} zoom={13} ref={mapRef} className="leaflet-container">
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
        <Marker key={1} position={branch} icon={HomeIcon}>
            <Popup>
            {detailOrder.branch.name}
            </Popup>
        </Marker>
        <Marker key={2} position={client} icon={redIcon}>
            <Popup>
            {detailOrder.client.address}
            </Popup>
        </Marker>     
      {delivery && (
        <Marker position={delivery} icon={blueIcon}>
          <Popup>Delivery</Popup>
        </Marker>
      )}
    </MapContainer>
  );
};
export default MapComponent;